import { constants, typographyStyles } from "@newsela/angelou";
const spacing = "0.5rem";
const grey = constants.colors.ui.neutral[500];
const { heading6Obj } = typographyStyles;
const greyDark = constants.colors.ui.neutral[600];

export const selectAssigneesInfoText = {
  color: grey,
  display: "flex",
  flexDirection: "row",
  aligntItems: "center",
  padding: "1rem 0 4rem",
};

export const assigneeManagementButtonsCss = {
  display: "flex",
  flexFlow: "row nowrap",
  justifyContent: "flex-start",
  ">*": {
    marginRight: spacing,
  },
  "> div > button": {
    height: "100%",
  },
};

export const iconSizeCss = {
  height: "26px",
  width: "26px",
  marginRight: "8px",
};

export const SGAassignmentEditorAssigneesLabelCss = [
  {
    color: greyDark,
    marginTop: spacing,
    fontWeight: "bold",
    lineHeight: 1.14,
    margin: "4rem 0 1rem",
  },
  heading6Obj,
];
